<div class="content dx-view-port">
  <router-outlet></router-outlet>
  <div class="version">{{version}}</div>
</div>
